import { UserProfileAction } from '../actions/userProfileActions'
import { SET_USER_PROFILE } from '../types/userProfileActionsTypes'
import { UserProfile } from '../../interfaces/User/User'

export interface userProfileState {
  userProfileState: { userProfile: UserProfile }
}

const initialState: userProfileState = {
  userProfileState: {
    userProfile: {
      authTime: 0,
      email: '',
      emailVerified: false,
      idp: '',
      name: '',
      preferredUsername: '',
      sHash: '',
      sid: '',
      sub: '',
      amr: [],
      role: [],
      tenant: ''
    }
  }
}

export const userProfileReducer = (
  state: userProfileState = initialState,
  action: UserProfileAction
): userProfileState => {
  if (action.type === SET_USER_PROFILE) {
    return {
      ...state,
      userProfileState: {
        userProfile: action.userProfile
      }
    }
  }
  return state
}
